import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import cx from 'classnames';
var css = {
  "content": "rui-Bi6gX",
  "list": "rui-0tvvb",
  "smoothScrollBehavior": "rui-sVxz8"
};
import Arrow from './Arrow';
var Carousel = /*#__PURE__*/function (_React$Component) {
  function Carousel(props) {
    var _this;
    _classCallCheck(this, Carousel);
    _this = _callSuper(this, Carousel, [props]);
    _this.componentDidMount = function () {
      return _this.handleScroll();
    };
    _this.handleScroll = function () {
      if (_this.itemList.current) {
        var _this$itemList$curren = _this.itemList.current,
          scrollWidth = _this$itemList$curren.scrollWidth,
          clientWidth = _this$itemList$curren.clientWidth,
          scrollLeft = _this$itemList$curren.scrollLeft;
        var direction = _this.props.direction;
        _this.setState({
          showArrowLeft: direction === 'ltr' ? scrollLeft === 0 : clientWidth + scrollLeft === scrollWidth,
          showArrowRight: direction === 'ltr' ? scrollWidth <= Math.ceil(scrollLeft + clientWidth) : scrollLeft === 0
        });
      }
    };
    _this.handleClickNext = function () {
      return _this.scroll(_this.props.direction === 'ltr' ? 1 : -1);
    };
    _this.handleClickPrev = function () {
      return _this.scroll(_this.props.direction === 'ltr' ? -1 : 1);
    };
    _this.state = {
      showArrowLeft: true,
      showArrowRight: true
    };
    _this.itemList = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(Carousel, _React$Component);
  return _createClass(Carousel, [{
    key: "scroll",
    value: function scroll(direction) {
      if (this.itemList.current) {
        var _this$itemList$curren2 = this.itemList.current,
          clientWidth = _this$itemList$curren2.clientWidth,
          scrollLeft = _this$itemList$curren2.scrollLeft;
        var _scroll = direction * clientWidth + scrollLeft;
        this.itemList.current.scrollLeft = _scroll;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        arrow = _this$props.arrow,
        children = _this$props.children,
        direction = _this$props.direction,
        className = _this$props.className,
        smoothScroll = _this$props.smoothScroll;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(css.content, className)
      }, arrow && (/*#__PURE__*/React.createElement(Arrow, {
        type: arrow,
        icon: "arrowLeft",
        disabled: this.state.showArrowLeft,
        onClick: this.handleClickPrev,
        direction: direction
      })), /*#__PURE__*/React.createElement("div", {
        className: cx(css.list, _defineProperty({}, css.smoothScrollBehavior, smoothScroll)),
        onScroll: this.handleScroll,
        ref: this.itemList
      }, children), arrow && (/*#__PURE__*/React.createElement(Arrow, {
        type: arrow,
        icon: "arrowRight",
        disabled: this.state.showArrowRight,
        onClick: this.handleClickNext,
        direction: direction
      })));
    }
  }]);
}(React.Component);
Carousel.defaultProps = {
  className: '',
  steps: 0,
  children: [],
  direction: 'ltr',
  smoothScroll: false
};
export default Carousel;